import React from 'react';
import { Row, Col, Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { isMobile, wait, Event } from 'utils/Helper';
import BankRoll from "../../components/Game/BankRoll";
import Queue from "../../components/Game/Queue";
import TopBarGames from "../../components/Game/Addons/TopBar";
import Game from "./Game";
import Bet from "./Bet";
import Engine from "./Engine";
import Loading from "../../games/Loading";
import "../../assets/css/blackjack.css"
import BestBlackJackPopup from './Graph';
import "./blackjack.css"

class Index extends React.Component {
    _Mounted = false;
    constructor(props) {
        super(props);
        this.state = {
            engine: new Engine(),
            padding: "p-1",
            showPopup: false
        };
        this.handleShowPopUp = this.handleShowPopUp.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    handleShowPopUp() {
        this.setState((prevState) => ({
            showPopup: !prevState.showPopup
        }));
    }

    componentDidMount() {
        let { engine } = this.state;

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        // Start Engine
        engine.started = true;

        wait(600).then(() => {
            this.handleResize();
        });
        window.addEventListener('resize', this.handleResize);
    }

    componentWillMount() {
        wait(500).then(() => {
            this._Mounted = true;
        })
    }

    componentWillUnmount() {
        let { engine } = this.state;
        window.removeEventListener('resize', this.handleResize);
        this._Mounted = false;

        // Stop Engine
        engine.started = false;
        engine.trigger = null;
        engine.off()
    }

    handleResize() {
        let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;

        if (clientWidth < 1540) {
            this.setState({ col: 'col-xl-12' });
            Event.emit('hide_games');
        }
        else {
            this.setState({ col: 'col-md-12'});
            Event.emit('show_min_games');
        }

        if (isMobile()) {
            this.setState({ padding: 'p-0', ovh: 'ovh' });
        }
    }


 


    render() {
        let { col, padding, ovh } = this.state;
        const help = <p className="text-white">Objective of the game: Each participant attempts to beat the dealer by getting a count as close to 21 as possible, without going over 21. Card values and scoring: It is up to each individual player if an ace is worth 1 or 11.<br /> Face cards are 10 and any other card is its pip value. Betting: Before the deal begins, each player places a bet in front of them in the designated area. The shuffle and cut: The dealer thoroughly shuffles portions of the pack until all the cards have been mixed and combined. The dealer designates one of the players to cut, and the plastic insert card is placed so that the last 60 to 75 cards or so will not be used.<br /> The deal: When you have placed your bet, the dealer will give you one card face up, and then one card face up to themselves. Another round of cards is then dealt face up to you, but the dealer takes the second card face down. Thus, each player except the dealer receives two cards face up, and the dealer receives one card face up and one card face down. The play: You will decide whether to "stand" (not ask for another card) or "hit" (ask for another card in an attempt to get closer to a count of 21, or even hit 21 exactly).<br /> Thus, you may stand on the two cards originally dealt to you, or you may ask the dealer for additional cards, one at a time, until deciding to stand on the total (if it is 21 or under) or goes "bust" (if it is over 21). In the latter case, the player loses, and the dealer collects the bet wagered. The combination of an ace with a card other than a ten-card is known as a "soft hand," because the player can count the ace as a 1 or 11, and either draw cards or not. For example with a "soft 17" (an ace and a 6), the total is 7 or 17.<br /> While a count of 17 is a good hand, the player may wish to draw for a higher total. If the draw creates a bust hand by counting the ace as an 11, the player simply counts the ace as a 1 and continues playing by standing or "hitting" (asking the dealer for additional cards, one at a time).</p>;
        return (
            <>
                <Helmet>
                    <title>BlackJack</title>
                   
                    <link rel="canonical" href="/blackjack" />
                </Helmet>
                <div>
                    {this._Mounted ?

                        <div className={`${col} ${padding}`} style={{ position: 'relative', width: '100%', height: '100%' }}>
                            {this.state.showPopup && (
                                <BestBlackJackPopup
                                    onClose={this.handleShowPopUp}
                                    engine={this.state.engine}
                                />
                            )}
                            <Row style={{marginTop:'20px'}} className={"animated fadeIn " + ovh}>
                                <div className="d-none">Crypto BlackJack Description: {help}</div>
                                <Col sm={12} className={'m-auto ' + col + ' ' + padding}>

                                    

                                    <div  className='goal-bets-and-game'>

                                        {/* BET */}
                                    <Card style={{padding:'0px',paddingTop:"20px"}} className="mb-0 col-md-4 goal-bet-main">
                                        <Card.Body className={padding}>
                                            <Row>
                                                <Col style={{padding:'0px'}} md={12} >
                                                    <Bet engine={this.state.engine} />
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        {/* TOP MENUS */}
                                    <Card className="mb-0 top-menus-limbo-bet">
                                        <Card.Body style={{borderTop:"1px solid #31343C"}} cclassName="px-2 py-3">
                                            <Row>
                                                {/* <Col md={6} className={'col-6 text-left'}>
                                                    <BankRoll game={'blackjack'} />
                                                </Col> */}
                                                 <Col md={12} style={{padding:"0px"}} className={' text-right'}>
                                                <div style={{ display: 'flex' }}>

                                                    <Col style={{padding:"0px"}} className={' text-right'}>
                                                        <TopBarGames help={help} image="/assets/images/covers_new/____hilo.png" />
                                                    </Col>
                                                    {/* <div onClick={this.handleShowPopUp} style={{ marginLeft: '26px', alignItems: 'center', height: '37px', width: '37px', borderRadius: '5px', backgroundColor: "#1B2336", display: 'flex', justifyContent: 'center' }}>
                                                        <img style={{ height: '17px', width: '17px' }} src="/assets/images/nanoicons/nanoswap.png" alt="Swap" />

                                                    </div> */}
                                                </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                    </Card>

                                    {/* GAME */}
                                    <Card style={{padding:'0px'}} className="mb-0 col-md-8 goal-game-main">
                                        <Card.Body className={'bg-dice-options p-1'} id="roll-panel">
                                            <Row>
                                                <Col style={{padding:"0px",paddingLeft:"2px"}} sm={12} md={12} className={'m-auto'}>
                                                    <Game engine={this.state.engine} />
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        {/* TOP MENUS */}
                                    <Card className="mb-0 goal-game-menus">
                                        <Card.Body  className="px-2 py-3">
                                            <Row>
                                                {/* <Col md={6} className={'col-6 text-left'}>
                                                    <BankRoll game={'blackjack'} />
                                                </Col> */}
                                                 <Col md={12} style={{padding:"0px"}} className={'text-right'}>
                                                <div style={{ display: 'flex' }}>

                                                    <Col style={{padding:"0px"}} className='text-right'>
                                                        <TopBarGames help={help} image="/assets/images/covers_new/____hilo.png" />
                                                    </Col>
                                                    {/* <div onClick={this.handleShowPopUp} style={{ marginLeft: '26px', alignItems: 'center', height: '37px', width: '37px', borderRadius: '5px', backgroundColor: "#1B2336", display: 'flex', justifyContent: 'center' }}>
                                                        <img style={{ height: '17px', width: '17px' }} src="/assets/images/nanoicons/nanoswap.png" alt="Swap" />

                                                    </div> */}
                                                </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                    </Card>

                                    

                                    </div>

                                    {/* QUEUE */}
                                    <Card style={{marginTop:'20px',borderRadius:"20px"}} className="mb-5">
                                        <Card.Body className="p-1">
                                            <Row>
                                                <Col sm={12} md={12} className={'m-auto px-1'}>
                                                    <Queue t={this.props.t} game={'blackjack'} />
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>

                                </Col>
                            </Row>
                        </div>
                        :
                        <Loading />
                    }
                </div>
            </>
        );
    }
}

export default Index;
